import { useState, useEffect, useRef } from 'react';
import { originBase } from '../util';

export default function TabIngreso({ event, api }) {
  // UN LINK POR PUESTO, no uno solo para todos: el nombre lo pone el dueño al crearlo,
  // así después se sabe quién escaneó cada entrada y se puede dar de baja el de uno solo.
  // 'ingreso' = puerta; 'traslado' = micro. Cada uno valida solo su propio QR.
  const [sesiones, setSesiones] = useState([]);
  const [anteriores, setAnteriores] = useState([]);
  const [stats, setStats] = useState({ ingresaron: 0, faltan: 0, total: 0 });
  const [hasTransport, setHasTransport] = useState(false);
  const [subtab, setSubtab] = useState('links'); // links | cumples
  const [birthdays, setBirthdays] = useState([]);
  const timer = useRef(null);

  const loadBirthdays = () => api.get(`/api/birthdays?event_id=${event.id}`).then(setBirthdays).catch(() => {});
  useEffect(() => { loadBirthdays(); }, []); // eslint-disable-line

  const loadSessions = () => api.get(`/api/scanning?event_id=${event.id}`)
    .then(rows => setSesiones((Array.isArray(rows) ? rows : []).filter(r => r.active)))
    .catch(() => {});

  // Los puestos del evento ANTERIOR, para poder recrearlos sin tipearlos de nuevo:
  // son casi siempre las mismas personas noche a noche.
  const loadAnteriores = () => api.get('/api/scanning').then(rows => {
    const otros = (Array.isArray(rows) ? rows : []).filter(r => r.event_id !== event.id && r.name);
    const vistos = new Set();
    setAnteriores(otros.filter(r => {
      const k = `${r.kind || 'ingreso'}|${r.name.toLowerCase()}`;
      if (vistos.has(k)) return false;
      vistos.add(k); return true;
    }).slice(0, 12));
  }).catch(() => {});

  async function revocar(s) {
    if (!window.confirm(`¿Dar de baja el link de ${s.name || 'este puesto'}?\n\nDeja de funcionar al instante. Lo ya escaneado no se toca.`)) return;
    try { await api.del(`/api/scanning/${s.id}`); loadSessions(); } catch (e) { alert(e.message); }
  }

  useEffect(() => {
    loadSessions();
    loadAnteriores();
    // ¿algún lote del evento incluye traslado? (para mostrar la sección del micro)
    api.get(`/api/events/${event.id}/lots`).then(ls => setHasTransport((Array.isArray(ls) ? ls : []).some(l => l.has_transport))).catch(() => {});
  }, []); // eslint-disable-line

  // ingreso en vivo (polling cada 4s)
  useEffect(() => {
    const tick = async () => {
      try {
        // Contadores calculados en la base (una fila). Antes se bajaba la lista
        // completa de tickets cada 4s solo para contarlos acá.
        const s = await api.get(`/api/scanning/stats?event_id=${event.id}`);
        setStats({ ingresaron: s.ingresaron, faltan: s.faltan, total: s.total });
      } catch (e) { /* noop */ }
    };
    tick();
    timer.current = setInterval(tick, 4000);
    return () => clearInterval(timer.current);
  }, []); // eslint-disable-line

  async function genScan(kind, name) {
    try {
      await api.post('/api/scanning', { event_id: event.id, kind, name });
      loadSessions();
    } catch (e) { alert(e.message); }
  }

  const pct = stats.total ? Math.round(stats.ingresaron / stats.total * 100) : 0;

  return (
    <div className="lb-fade" style={{ paddingTop: 24 }}>
      <div className="lb-subtabs" style={{ marginBottom: 20 }}>
        <button className={subtab === 'links' ? 'active' : ''} onClick={() => setSubtab('links')}>Links de escaneo</button>
        <button className={subtab === 'cumples' ? 'active' : ''} onClick={() => setSubtab('cumples')}>Lista de cumpleaños</button>
      </div>

      {subtab === 'links' && (
      <div className="tk-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 30, alignItems: 'start' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <PuestosDeEscaneo
          titulo="Links de escaneo · Puerta"
          desc="Uno por persona. Le das a cada quien SU link, y así después sabés quién escaneó cada entrada. No necesitan cuenta."
          kind="ingreso"
          sesiones={sesiones.filter(s => (s.kind || 'ingreso') === 'ingreso')}
          anteriores={anteriores.filter(s => (s.kind || 'ingreso') === 'ingreso')}
          onCrear={(name) => genScan('ingreso', name)}
          onRevocar={revocar}
        />
        {hasTransport && (
          <PuestosDeEscaneo
            titulo="Links de escaneo · Traslado"
            desc="Para quien controla el traslado. Solo valida el QR de traslado — no ve ni toca los de ingreso."
            kind="traslado"
            sesiones={sesiones.filter(s => s.kind === 'traslado')}
            anteriores={anteriores.filter(s => s.kind === 'traslado')}
            onCrear={(name) => genScan('traslado', name)}
            onRevocar={revocar}
            nota="Un solo uso por QR: una captura duplicada da “YA USADO”."
          />
        )}
      </div>

      <div className="lb-card" style={{ padding: '24px 26px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className="lb-eyebrow">Ingreso en vivo</div>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'var(--red-400)' }}>
            <span style={{ width: 6, height: 6, borderRadius: 999, background: 'var(--red-400)', boxShadow: '0 0 8px var(--red-400)' }} />EN VIVO
          </span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginTop: 18 }}>
          <Stat label="Ingresaron" value={stats.ingresaron} />
          <Stat label="Faltan ingresar" value={stats.faltan} accent />
        </div>
        <div style={{ marginTop: 18, height: 8, background: 'var(--ink-300)', position: 'relative', borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ position: 'absolute', inset: 0, width: pct + '%', background: 'var(--red-500)', transition: 'width 300ms var(--ease-out)' }} />
        </div>
        <div style={{ marginTop: 8, fontSize: 12, color: 'var(--ink-700)' }}>{pct}% del público presente</div>
      </div>
      </div>
      )}

      {subtab === 'cumples' && <BirthdayList birthdays={birthdays} onReload={loadBirthdays} api={api} event={event} />}
    </div>
  );
}

// Lista de cumpleaños del evento: ordenada por apellido/nombre, con estado, quién lo cargó,
// alta manual (dueño) e impresión.
function BirthdayList({ birthdays, onReload, api, event }) {
  const [f, setF] = useState({ last_name: '', first_name: '' });
  const [attested, setAttested] = useState(false);
  const [attest, setAttest] = useState(false);
  const entregados = birthdays.filter(b => b.status === 'entregado').length;

  useEffect(() => { api.get(`/api/birthdays/attested?event_id=${event.id}`).then(d => setAttested(!!d.attested)).catch(() => {}); }, [event.id]); // eslint-disable-line

  async function add() {
    if (!f.first_name.trim() || !f.last_name.trim()) { alert('Nombre y apellido'); return; }
    if (!attested && !attest) { alert('Primero marcá la declaración de que contás con la autorización del padre/madre/tutor.'); return; }
    try { await api.post('/api/birthdays', { event_id: event.id, first_name: f.first_name, last_name: f.last_name, attest }); setF({ last_name: '', first_name: '' }); setAttested(true); onReload(); }
    catch (e) { alert(e.message); }
  }
  async function del(id) { try { await api.del(`/api/birthdays/${id}`); onReload(); } catch (e) { alert(e.message); } }

  function print() {
    // La impresa lleva DNI y fecha de nacimiento: es la que se usa en la puerta para
    // comparar contra el documento físico. Y quién lo cargó, para saber a quién preguntarle.
    const rows = birthdays.map((b, i) => `<tr><td>${i + 1}</td><td>${esc(b.last_name)}, ${esc(b.first_name)}</td><td>${esc(b.dni || '')}</td><td>${esc(diaMesAnio(b.birthdate))}</td><td>${b.source === 'web' ? 'WEB' : esc(b.added_by_name || '')}</td><td>${b.status === 'entregado' ? 'INGRESÓ' : ''}</td></tr>`).join('');
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Cumpleaños · ${esc(event.name)}</title>
      <style>body{font-family:Arial,sans-serif;color:#000;padding:20px} h1{font-size:18px} table{width:100%;border-collapse:collapse;font-size:14px} td,th{border-bottom:1px solid #ccc;padding:6px 8px;text-align:left} td:first-child{width:36px;color:#888} td:last-child{width:80px}</style>
      </head><body><h1>Lista de cumpleaños · ${esc(event.name)}</h1><p>${birthdays.length} personas</p>
      <table><thead><tr><th>#</th><th>Apellido y nombre</th><th>DNI</th><th>Nacimiento</th><th>Cargado por</th><th>Ingreso</th></tr></thead><tbody>${rows}</tbody></table></body></html>`;
    const old = document.getElementById('tk-bd-print'); if (old) old.remove();
    const iframe = document.createElement('iframe'); iframe.id = 'tk-bd-print';
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    document.body.appendChild(iframe);
    iframe.onload = () => { try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch (e) { /* noop */ } setTimeout(() => { try { iframe.remove(); } catch {} }, 1500); };
    const doc = iframe.contentWindow.document; doc.open(); doc.write(html); doc.close();
  }

  return (
    <div className="lb-fade" style={{ maxWidth: 720 }}>
      <div className="lb-card" style={{ padding: '18px 22px', marginBottom: 16 }}>
        <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Agregar a la lista</div>
        {!attested && (
          <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 12.5, color: 'var(--ink-700)', lineHeight: 1.45, cursor: 'pointer', marginBottom: 14, padding: '12px 14px', border: '1px solid rgba(236,38,143,0.4)', borderRadius: 6, background: 'rgba(236,38,143,0.05)' }}>
            <input type="checkbox" checked={attest} onChange={e => setAttest(e.target.checked)} style={{ marginTop: 2 }} />
            <span>Declaro que cuento con la <b style={{ color: '#fff' }}>autorización del padre, madre o tutor</b> de cada invitado para cargar sus datos. <span style={{ color: 'var(--ink-600)' }}>(Se pide una sola vez por evento.)</span></span>
          </label>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input className="lb-input" style={{ flex: 1, minWidth: 130 }} placeholder="Apellido" value={f.last_name} onChange={e => setF({ ...f, last_name: e.target.value })} />
          <input className="lb-input" style={{ flex: 1, minWidth: 130 }} placeholder="Nombre" value={f.first_name} onChange={e => setF({ ...f, first_name: e.target.value })} onKeyDown={e => e.key === 'Enter' && add()} />
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={add}>+ Agregar</button>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
        <div className="lb-eyebrow">Cumpleañeros · {birthdays.length} ({entregados} ingresaron)</div>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={print} disabled={birthdays.length === 0}>Imprimir lista</button>
      </div>
      <div className="lb-card tk-scroll-x" style={{ padding: '6px 20px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '2fr 1fr 1.2fr auto' }}>
          <span>Apellido y nombre</span><span>Estado</span><span>Cargado por</span><span></span>
        </div>
        {birthdays.map(b => (
          <div key={b.id} className="lb-row" style={{ gridTemplateColumns: '2fr 1fr 1.2fr auto', alignItems: 'center' }}>
            <span>
              <span style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>{b.last_name}, <span style={{ fontWeight: 400, color: 'var(--ink-800)' }}>{b.first_name}</span></span>
              {/* Documento y fecha de nacimiento: los traen los que se anotaron solos por la
                  web. Es lo que boletería compara contra el documento físico. */}
              {(b.dni || b.birthdate) && (
                <span style={{ display: 'block', fontSize: 11, color: 'var(--ink-600)', marginTop: 2 }}>
                  {b.dni ? `DNI ${b.dni}` : ''}{b.dni && b.birthdate ? ' · ' : ''}{b.birthdate ? `nació el ${diaMesAnio(b.birthdate)}` : ''}
                </span>
              )}
            </span>
            <span><span className={'lb-status lb-status--' + (b.status === 'entregado' ? 'used' : 'gen')}>{b.status === 'entregado' ? 'Ingresó' : 'Pendiente'}</span></span>
            {/* WEB = se anotó solo. NO se deduce de que no haya RRPP: `added_by` queda en
                NULL cuando se borra al vendedor, así que eso haría que sus cumpleañeros
                pasaran a decir WEB solos. Viene del campo `source`. */}
            <span style={{ fontSize: 12, color: 'var(--ink-700)' }}>
              {b.source === 'web'
                ? <span className="lb-status lb-status--paid">WEB</span>
                : (b.added_by_name || '—')}
            </span>
            <span style={{ textAlign: 'right' }}>{b.status === 'pending' ? <button className="lb-iconbtn" onClick={() => del(b.id)}>✕</button> : null}</span>
          </div>
        ))}
        {birthdays.length === 0 && <div style={{ padding: '20px 0', textAlign: 'center', fontSize: 13, color: 'var(--ink-600)' }}>Sin cumpleañeros cargados. Los RRPP los agregan desde su panel.</div>}
      </div>
    </div>
  );
}

function esc(s) { return String(s || '').replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c])); }

// '2000-09-02' -> '02/09/2000'. Se parte el string en vez de usar Date: `new Date('2000-09-02')`
// es medianoche UTC y en Argentina se muestra un día antes. Ver [[zona-horaria]].
function diaMesAnio(iso) {
  const p = String(iso || '').slice(0, 10).split('-');
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : '';
}

// PUESTOS DE ESCANEO: un link por persona. El nombre se pone acá, al crearlo, y no en el
// teléfono de quien escanea — si se escribiera allá, cualquiera podría poner cualquier
// cosa y un celular que cambia de manos quedaría mal atribuido.
function PuestosDeEscaneo({ titulo, desc, sesiones, anteriores, onCrear, onRevocar, nota }) {
  const [nombre, setNombre] = useState('');
  const [copiado, setCopiado] = useState(null);

  const url = (s) => `${originBase()}/scan/${s.token}`;
  function copiar(s) {
    navigator.clipboard?.writeText(url(s));
    setCopiado(s.id); setTimeout(() => setCopiado(null), 1800);
  }
  function crear() {
    const n = nombre.trim();
    if (!n) { alert('Poné un nombre para identificar el puesto: "Pedro", "Puerta 2", "Roberto".'); return; }
    onCrear(n); setNombre('');
  }
  // Nombres del evento anterior que todavía no están en este: se recrean con un clic.
  const usados = new Set(sesiones.map(s => (s.name || '').toLowerCase()));
  const sugeridos = (anteriores || []).filter(a => !usados.has((a.name || '').toLowerCase()));

  return (
    <div className="lb-card" style={{ padding: '24px 26px' }}>
      <div className="lb-eyebrow" style={{ marginBottom: 14 }}>{titulo}</div>
      <p style={{ color: 'var(--ink-700)', fontSize: 14, marginTop: 0 }}>{desc}</p>
      {nota && <p style={{ color: 'var(--red-400)', fontSize: 12, marginTop: -6 }}>{nota}</p>}

      <div style={{ display: 'flex', gap: 8, marginBottom: sesiones.length ? 16 : 0 }}>
        <input className="lb-input" style={{ flex: 1 }} value={nombre} maxLength={60}
          onChange={e => setNombre(e.target.value)} onKeyDown={e => e.key === 'Enter' && crear()}
          placeholder="Nombre del puesto: Pedro, Puerta 2…" />
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={crear}>+ Crear link</button>
      </div>

      {/* Recrear los del evento anterior: son casi siempre las mismas personas y
          tipearlos de nuevo cada noche es trabajo al pedo. */}
      {sugeridos.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: 'var(--ink-600)', marginBottom: 6 }}>De noches anteriores:</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {sugeridos.map(a => (
              <button key={a.id} className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => onCrear(a.name)}>+ {a.name}</button>
            ))}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {sesiones.map(s => (
          <div key={s.id} style={{ background: 'var(--ink-050)', border: '1px solid var(--border)', borderRadius: 4, padding: '10px 12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ flex: 1, color: '#fff', fontSize: 13, fontWeight: 600 }}>{s.name || 'Sin nombre'}</span>
              <button className="lb-btn lb-btn--white lb-btn--sm" onClick={() => copiar(s)}>{copiado === s.id ? 'Copiado ✓' : 'Copiar'}</button>
              <a className="lb-btn lb-btn--ghost lb-btn--sm" href={url(s)} target="_blank" rel="noreferrer">Abrir ↗</a>
              <button className="lb-iconbtn" title="Dar de baja este link" onClick={() => onRevocar(s)}>✕</button>
            </div>
            <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{url(s)}</div>
          </div>
        ))}
        {sesiones.length === 0 && (
          <div style={{ fontSize: 12.5, color: 'var(--ink-600)', lineHeight: 1.5 }}>
            Todavía no hay ningún puesto. Creá uno por cada persona que vaya a escanear.
          </div>
        )}
      </div>
    </div>
  );
}

function Stat({ label, value, accent }) {
  return (
    <div className="lb-stat">
      <div className="lb-eyebrow">{label}</div>
      <div className="num" style={{ fontSize: 40, color: accent ? 'var(--red-400)' : 'var(--white)' }}>{value}</div>
    </div>
  );
}
